/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBiomeObservationDeleteResultDto,
  ApiEnvelopeBiomeObservationDto,
  ApiEnvelopeBiomeObservationListDto,
  ApiEnvelopeBiomeObservationRunListDto,
  BiomeObservationCreateRequest,
  BiomeObservationExportParams,
  BiomeObservationGetMineParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type biomeObservationGetMineResponse200 = {
  data: ApiEnvelopeBiomeObservationListDto
  status: 200
}

export type biomeObservationGetMineResponse401 = {
  data: ApiEnvelopeBiomeObservationListDto
  status: 401
}

export type biomeObservationGetMineResponseSuccess = (biomeObservationGetMineResponse200) & {
  headers: Headers;
};
export type biomeObservationGetMineResponseError = (biomeObservationGetMineResponse401) & {
  headers: Headers;
};

export type biomeObservationGetMineResponse = (biomeObservationGetMineResponseSuccess | biomeObservationGetMineResponseError)

export const getBiomeObservationGetMineUrl = (params?: BiomeObservationGetMineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/BiomeObservation?${stringifiedParams}` : `/api/BiomeObservation`
}

export const useBiomeObservationGetMineHook = (): (params?: BiomeObservationGetMineParams, options?: RequestInit) => Promise<biomeObservationGetMineResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: BiomeObservationGetMineParams, options?: RequestInit) => {

        return customFetcher(getBiomeObservationGetMineUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type biomeObservationCreateResponse200 = {
  data: ApiEnvelopeBiomeObservationDto
  status: 200
}

export type biomeObservationCreateResponse400 = {
  data: ApiEnvelopeBiomeObservationDto
  status: 400
}

export type biomeObservationCreateResponse401 = {
  data: ApiEnvelopeBiomeObservationDto
  status: 401
}

export type biomeObservationCreateResponseSuccess = (biomeObservationCreateResponse200) & {
  headers: Headers;
};
export type biomeObservationCreateResponseError = (biomeObservationCreateResponse400 | biomeObservationCreateResponse401) & {
  headers: Headers;
};

export type biomeObservationCreateResponse = (biomeObservationCreateResponseSuccess | biomeObservationCreateResponseError)

export const getBiomeObservationCreateUrl = () => {




  return `/api/BiomeObservation`
}

export const useBiomeObservationCreateHook = (): (biomeObservationCreateRequest?: BiomeObservationCreateRequest, options?: RequestInit) => Promise<biomeObservationCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (biomeObservationCreateRequest?: BiomeObservationCreateRequest, options?: RequestInit) => {

        return customFetcher(getBiomeObservationCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(biomeObservationCreateRequest)
  }
);
      }
  }


export type biomeObservationDeleteAllMineResponse200 = {
  data: ApiEnvelopeBiomeObservationDeleteResultDto
  status: 200
}

export type biomeObservationDeleteAllMineResponse401 = {
  data: ApiEnvelopeBiomeObservationDeleteResultDto
  status: 401
}

export type biomeObservationDeleteAllMineResponseSuccess = (biomeObservationDeleteAllMineResponse200) & {
  headers: Headers;
};
export type biomeObservationDeleteAllMineResponseError = (biomeObservationDeleteAllMineResponse401) & {
  headers: Headers;
};

export type biomeObservationDeleteAllMineResponse = (biomeObservationDeleteAllMineResponseSuccess | biomeObservationDeleteAllMineResponseError)

export const getBiomeObservationDeleteAllMineUrl = () => {




  return `/api/BiomeObservation`
}

export const useBiomeObservationDeleteAllMineHook = (): ( options?: RequestInit) => Promise<biomeObservationDeleteAllMineResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBiomeObservationDeleteAllMineUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type biomeObservationGetRunsResponse200 = {
  data: ApiEnvelopeBiomeObservationRunListDto
  status: 200
}

export type biomeObservationGetRunsResponse401 = {
  data: ApiEnvelopeBiomeObservationRunListDto
  status: 401
}

export type biomeObservationGetRunsResponseSuccess = (biomeObservationGetRunsResponse200) & {
  headers: Headers;
};
export type biomeObservationGetRunsResponseError = (biomeObservationGetRunsResponse401) & {
  headers: Headers;
};

export type biomeObservationGetRunsResponse = (biomeObservationGetRunsResponseSuccess | biomeObservationGetRunsResponseError)

export const getBiomeObservationGetRunsUrl = () => {




  return `/api/BiomeObservation/runs`
}

export const useBiomeObservationGetRunsHook = (): ( options?: RequestInit) => Promise<biomeObservationGetRunsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBiomeObservationGetRunsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type biomeObservationDeleteResponse200 = {
  data: ApiEnvelopeBiomeObservationDeleteResultDto
  status: 200
}

export type biomeObservationDeleteResponse401 = {
  data: ApiEnvelopeBiomeObservationDeleteResultDto
  status: 401
}

export type biomeObservationDeleteResponse404 = {
  data: ApiEnvelopeBiomeObservationDeleteResultDto
  status: 404
}

export type biomeObservationDeleteResponseSuccess = (biomeObservationDeleteResponse200) & {
  headers: Headers;
};
export type biomeObservationDeleteResponseError = (biomeObservationDeleteResponse401 | biomeObservationDeleteResponse404) & {
  headers: Headers;
};

export type biomeObservationDeleteResponse = (biomeObservationDeleteResponseSuccess | biomeObservationDeleteResponseError)

export const getBiomeObservationDeleteUrl = (id: string,) => {




  return `/api/BiomeObservation/${id}`
}

export const useBiomeObservationDeleteHook = (): (id: string, options?: RequestInit) => Promise<biomeObservationDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBiomeObservationDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type biomeObservationExportResponse200 = {
  data: Blob
  status: 200
}

export type biomeObservationExportResponseSuccess = (biomeObservationExportResponse200) & {
  headers: Headers;
};
;

export type biomeObservationExportResponse = (biomeObservationExportResponseSuccess)

export const getBiomeObservationExportUrl = (params?: BiomeObservationExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/BiomeObservation/export?${stringifiedParams}` : `/api/BiomeObservation/export`
}

export const useBiomeObservationExportHook = (): (params?: BiomeObservationExportParams, options?: RequestInit) => Promise<biomeObservationExportResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: BiomeObservationExportParams, options?: RequestInit) => {

        return customFetcher(getBiomeObservationExportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


